"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var WixSocialPostsSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M15.4026525,10.5953865 L15.4142136,10.6069476 C16.1481054,11.3408394 16.1867313,12.5067141 15.5300912,13.2860778 L15.4026529,13.4237188 L12.5004327,16.281846 L9.58843044,13.4122526 C8.85453861,12.6783608 8.81591272,11.5124861 9.47255278,10.7331224 L9.59999147,10.5953865 C10.3356411,9.85973691 11.5028716,9.81638685 12.289348,10.4686704 L12.4167627,10.5838259 L12.5004327,10.6666 L12.5858813,10.5838259 C13.3687481,9.8137069 14.6261335,9.81886749 15.4026525,10.5953865 Z M14,3 C14.5522847,3 15,3.44771525 15,4 L15,9 L14,9 L14,4 L4,4 L4,14 L8,14 L8,15 L4,15 C3.44771525,15 3,14.5522847 3,14 L3,4 C3,3.44771525 3.44771525,3 4,3 L14,3 Z M10.402801,11.2181879 L10.3070983,11.3024933 L10.2373026,11.3774497 C9.93785694,11.7328607 9.9324297,12.2484199 10.2099384,12.6082212 L10.3012699,12.7108317 L12.501322,14.8670113 L14.7042463,12.7079946 C15.0614769,12.3507749 15.0889562,11.7926156 14.788934,11.4067227 L14.6955458,11.3024933 C14.3371523,10.9440999 13.7738928,10.9143326 13.3771578,11.2189578 L13.2816582,11.3020839 L12.4930759,12.065984 L11.7462476,11.3257218 L11.6509638,11.2383882 C11.2893162,10.9384469 10.76865,10.9350829 10.402801,11.2181879 Z M6.5,5 C7.32842712,5 8,5.67157288 8,6.5 C8,7.32842712 7.32842712,8 6.5,8 C5.67157288,8 5,7.32842712 5,6.5 C5,5.67157288 5.67157288,5 6.5,5 Z M13,6 L13,7 L9,7 L9,6 L13,6 Z M6.5,6 C6.22385763,6 6,6.22385763 6,6.5 C6,6.77614237 6.22385763,7 6.5,7 C6.77614237,7 7,6.77614237 7,6.5 C7,6.22385763 6.77614237,6 6.5,6 Z" })));
};
WixSocialPostsSmall.displayName = 'WixSocialPostsSmall';
exports.default = WixSocialPostsSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=WixSocialPostsSmall.js.map